/**
 * UPGRADE.ROUTE
 * Ask for premium version
 */

import NavApp from "@/nav/nav.app"
import UpgradeWidget from "@/widgets/upgrade.widget"

function UpgradeRoute() {
  return (
    <NavApp>
      <UpgradeWidget feature="survey" isAppLevel />
    </NavApp>
  )
}

export default UpgradeRoute
